import {
    MILITARY_VARIANT,
    STC_VARIANT,
    collection,
    isMilitaryEnabled,
    parentTypeFor,
} from "../_variants/index.js";
import {
    addServiceBulletin,
    cancelServiceBulletin,
    editServiceBulletin,
    linkServiceBulletin,
    reviseServiceBulletin,
    signoffServiceBulletin,
    unlinkServiceBulletin
} from "./actions";

import store from "../../../store";

function warning(key) {
    let item = store.state[key];
    if (!item || item.Cancelled === true) return false;
    let warningMessage = "";
    if (item && item.Signedoff === false) {
        warningMessage = warningMessage += `${item.Number} is not signedoff.<br>`;
    }
    return warningMessage === "" ? false : warningMessage;
}

const cellClassRules = {
    "text-orange font-bold": params => {
        return warning(params.data);
    }
}

const headers = [{
    "headerName": "Number",
    "field": "Number",
    cellClassRules
}, {
    "headerName": "Comment",
    "field": "Comment",
    cellClassRules
}, {
    "headerName": "Revision",
    "field": "Revision",
    cellClassRules
}, {
    "headerName": "Resolved",
    "field": "Signedoff",
    "type": "bool"
}];

const ADDABLE_PARENT_TYPES = ["DesignChanges", "FlightConditions", "Repairs", "MilitaryDesignChanges", "MilitaryFlightConditions", "MilitaryRepairs"];

/**
 * Build the attachable-table descriptor for the Service Bulletin register
 * that matches the supplied variant.
 *
 * @param {import("../_variants/index.js").Variant} variant
 */
export const makeServiceBulletinAttachable = (variant) => {
    const isMilitary = variant.key === "military";
    const labelSingular = isMilitary ? "Military Service Bulletin" : "Service Bulletin";
    const labelPlural = isMilitary ? "Military Service Bulletins" : "Service Bulletins";
    const sbParentType = parentTypeFor(variant, "ServiceBulletins");
    const sbCollection = collection(variant, "ServiceBulletins");

    const actions = [{
        "label": `Add ${labelSingular}`,
        "action": addServiceBulletin,
        show({ meta }) {
            return [ADDABLE_PARENT_TYPES.includes(meta?.ParentType), `${labelPlural} cannot be added here, they must be linked.`]
        }
    }, {
        "label": `Link ${labelSingular}`,
        "action": linkServiceBulletin
    }];

    const rowActions = [{
        "label": `View ${labelSingular}`,
        action({ router, rowItem }) {
            router.push(`/Database/${sbParentType}/${rowItem.ID}`)
        }
    }, {
        "label": `Update ${labelSingular}`,
        "break": true,
        "action": editServiceBulletin
    }, {
        "label": `Signoff ${labelSingular}`,
        "action": signoffServiceBulletin,
        show({ rowItem }) {
            return [!rowItem.Signedoff, "This Service Bulletin is already signed off"];
        }
    }, {
        "label": `Revise ${labelSingular}`,
        "break": true,
        "action": reviseServiceBulletin
    }, {
        "label": `Unlink ${labelSingular}`,
        "break": true,
        "action": unlinkServiceBulletin,
        show({ rowItem, pageItem }) {
            return [rowItem.ParentID !== pageItem.ID, "Cannot unlink this Service Bulletin"];
        }
    }, {
        "label": `Cancel ${labelSingular}`,
        "break": true,
        "action": cancelServiceBulletin,
        "class": "text-red"
    }];

    return {
        "label": labelPlural,
        "key": sbParentType,
        "location": `${sbCollection}/`,
        actions,
        rowActions,
        headers,
        warn({ items }) {
            let warningMessage = items.map(warning).filter(i => i !== false).join("");
            return [warningMessage !== "", warningMessage];
        }
    };
};

export const serviceBulletinAttachable = makeServiceBulletinAttachable(STC_VARIANT);
export const militaryServiceBulletinAttachable = isMilitaryEnabled() ? makeServiceBulletinAttachable(MILITARY_VARIANT) : null;

export default serviceBulletinAttachable;
